import type { AddressDto } from '@djust-b2b/djust-front-sdk/lib/interfaces/models/address';
import type { QuoteGetters } from './types';

export function useQuoteGetters(): QuoteGetters {
  const getQuoteProductVariantId = (quoteLine: any): string => quoteLine.productVariant?.id;

  const getQuoteProductVariantName = (quoteLine: any): string => quoteLine.productVariant?.name;

  const getQuoteProductVariantMpn = (quoteLine: any): string => quoteLine.productVariant?.mpn;

  const getQuoteProductVariantImageLink = (quoteLine: any): string =>
    quoteLine.productVariant?.mainImageUrl;

  const getQuoteProductVariantSku = (quoteLine: any): string =>
    quoteLine.productVariant?.skuVariant;

  const getQuoteProductVariantExternalSku = (quoteLine: any): string =>
    quoteLine.productVariant?.externalSku;

  const getQuoteProductVariantBrand = (quoteLine: any): string => quoteLine.productVariant?.brand;

  const getQuoteProductVariantAttributes = (quoteLine: any) =>
    quoteLine.productVariant?.attributeValuesVariant || [];

  const getQuoteBillingAddress = (quote: MasterQuote): AddressDto =>
    quote?.supplierQuotes[0]?.billingAddress;

  const getQuoteShippingAddress = (quote: MasterQuote): AddressDto =>
    quote?.supplierQuotes[0]?.quoteLines[0]?.quoteDeliveryLines[0].shippingAddress;

  return {
    getQuoteProductVariantId,
    getQuoteProductVariantName,
    getQuoteProductVariantMpn,
    getQuoteProductVariantImageLink,
    getQuoteProductVariantSku,
    getQuoteProductVariantExternalSku,
    getQuoteProductVariantBrand,
    getQuoteProductVariantAttributes,
    getQuoteBillingAddress,
    getQuoteShippingAddress,
  };
}
